<template>
  <div :class="[$route.name + '_main-ape', 'secondary-nav', { 'secondary-nav--collapsed': collapse || !showInnerMenu }]">
    <div :class="['menu-container', { 'menu-container--collapsed': collapse || !showInnerMenu }]">
      <div :class="{ 'menu-collapsed': collapse }">
        <el-menu v-if='showInnerMenu' :default-active='routePath' :background-color='`#fff`'
                 :text-color='`#333333`'
                 :active-text-color='`#ff3176`' class='el-submenu-header'
                 mode='horizontal'
                 @select='handleMenuSelect'>
          <el-menu-item v-for='(menu,key) in menus' :key='key' :index='menu.url'
                        :disabled='userPermissions.indexOf(menu.permission_name) === -1||menu.disabled'>
            <span>{{ menu.display_name }}</span>
          </el-menu-item>
        </el-menu>
      </div>

      <div
        :class="['btn-collapse', { 'is-collapsed': collapse }]"
        :title='collapse ? "展开子菜单" : "收起子菜单"'
        v-show='showInnerMenu'
        @click='handleCollapse'>
        <i :class='[collapse ? "el-icon-s-unfold" : "el-icon-s-fold"]'></i>
        <span>{{ collapse ? '展开菜单' : '收起菜单' }}</span>
      </div>
    </div>

    <div :class="$route.name === 'enrollDetail' ? 'enroll-detail-content' : `main-content_bg ${$route.name}_main-content`">
      <transition name='el-fade-in-linear'>
        <keep-alive v-if='$route.meta&&$route.meta.alive!==undefined&&$route.meta.alive'>
          <router-view></router-view>
        </keep-alive>
        <router-view v-else></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ApeMenu',
  computed: {
    ...mapGetters(['routePath', 'userPermissions']),
    showInnerMenu() {
      return this.$route.meta.hideInnerMenu === undefined ? true : !(this.$route.meta.hideInnerMenu)
    }
  },
  props: {
    menus: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      collapse: false
    }
  },
  methods: {
    handleMenuSelect(routePath) {
      if (!routePath) return
      const menu = this.menus.find(m => m.url === routePath)
      if (menu && menu.type === 'button') {
        let url = menu.url
        if (!/^https?:\/\//i.test(url)) {
          url = 'https://' + url
        }
        window.open(url, '_blank')
      } else {
        this.$router.push(routePath)
      }
    },
    handleCollapse() {
      this.collapse = !this.collapse
    }
  }
}
</script>

<style lang='scss' scoped>

.secondary-nav .el-menu-item {
  font-size: 14px !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 10px;
  border-bottom: none;
}

.secondary-nav {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

.menu-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  min-height: 40px;
  flex: 0 0 40px;
  padding-right: 118px;
  //border: red 1px dashed;
  background: #ffffff !important;
  box-sizing: border-box;
}

.menu-container--collapsed {
  height: 0;
  min-height: 0;
  flex-basis: 0;
  background: transparent !important;
}

.menu-collapsed {
  display: none;
}

.btn-collapse {
  position: absolute;
  top: 4px;
  right: 12px;
  z-index: 20;
  height: 32px;
  padding: 0 12px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.08);
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;
  line-height: 32px;
  user-select: none;
  transition: color 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.btn-collapse:hover {
  color: #ff3176;
  background: #fff0f6;
  border-color: #ffd1e2;
  box-shadow: 0 6px 16px rgba(255, 49, 118, 0.12);
}

.btn-collapse i {
  font-size: 15px;
}

.btn-collapse.is-collapsed {
  top: 8px;
}

/*.el-menu-item li {*/
/*  border: #fe346e 1px dashed !important;*/
/*}*/

::v-deep .el-menu-item + .is-active, .el-menu--horizontal > .el-menu-item.is-active {
  //border-bottom: none !important;
  background: linear-gradient(150deg, #FFEDF3, #faf0ff, #FFEDF3) !important;
  border-radius: 2px;
  border: var(--primary) 1px solid !important;
}

::v-deep .el-menu.el-menu--horizontal {
  //padding: 4px 0;
  width: 100%;
  //box-shadow: 2px 0 black;
  margin: 0 0;
}

.main-content_bg {
  flex: 1 1 auto;
  min-height: 0 !important;
  background-color: white;
  margin-top: 6px;
  padding: 8px 10px 0 10px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.inquiriesList_main-content,
.YearFrame_main-content,
.inquiryEnrollList_main-content,
.yearEnrollInquiryList_main-content {
  padding: 0;
  overflow:hidden!important;
}

.secondary-nav--collapsed .main-content_bg {
  margin-top: 0;
}

.enroll-detail-content {
  flex: 1 1 auto;
  min-height: 0 !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.sign_detail_main-content,
.sign_create_main-content,
.transfer_group_main-content,
.sign_fired_main-content,
.sign_overview_main-content {
  background-color: transparent;
}

.sign_create_main-content,
.transfer_group_main-content,
.sign_fired_main-content,
.sign_overview_main-content {
  padding: 0;
  overflow: hidden;
}
</style>
